<template>
  <div>
    <div class="col-md-12" style="padding-left: 5%; padding-right: 5%;">
      <div class="bg-plans-form mt-10">
        <h2>
          จัดการข้อมูลอาคาร
        </h2>
        <br />
        <b-button variant="success" @click="buildingActionModal()">+ เพิ่มชื่ออาคาร</b-button>
        <table ref="table_1" id="table_1" class="display" style="width:100%">
        </table>

      </div>
    </div>
    <b-modal id="buildingCreateForm" ref="buildingActionModal" centered no-enforce-focus size="lg" title="เพิ่มบริษัท">
      <label class="mr-sm-2">ชื่ออาคาร</label>
      <b-form-input v-model="buildingCreateForm.buildingName" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">ยี่ห้อ</label>
      <b-form-input v-model="buildingCreateForm.brandName" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">จำนวนลิฟท์</label>
      <b-form-input v-model="buildingCreateForm.numberOfElevator" size="sm" type="number"></b-form-input>

      <label class="mr-sm-2 mt-3">จำนวนชั้น</label>
      <b-form-input v-model="buildingCreateForm.numberOfFloors" size="sm" type="number"></b-form-input>

      <label class="mr-sm-2 mt-3">พิกัด</label>
      <b-form-input v-model="buildingCreateForm.locationUrl" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">บริษัท</label>
      <b-form-select id="buildingCreateForm_companyData" class="plans-form-select-lg custom-select2"
        v-model="buildingCreateForm.companyData" :options="formSetting.companyData"></b-form-select>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmActionbuilding()">
          ยืนยีน
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FetchService from "@/core/services/fetch.service";
import DataTable from 'datatables.net-bs4';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import $ from "jquery";
import moment from "moment";
import ThaiTambons from '@/assets/master_data/thai_geo_data/thai_tambons.json'
import ThaiAmphures from '@/assets/master_data/thai_geo_data/thai_amphures.json'
import ThaiProvinces from '@/assets/master_data/thai_geo_data/thai_provinces.json'
import Swal from 'sweetalert2'
export default {
  data() {
    return {
      masterDataTable: {},
      dataTable: [],
      masterData: [],
      masterFormData: {
        companyData: []
      },
      buildingCreateForm: {
        buildingName: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        locationUrl: "",
        companyData: ""
      },
      buildingEditMode: 0,
      buildingIdSelect: "",
      formSetting: {
        buildingName: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        locationUrl: "",
        companyData: ""
      },
    };
  },
  mounted() {
    this.getCompanyData()
    setTimeout(() => {
      this.getDataTable()
    }, 100)
  },
  methods: {
    getDataTable() {
      if (this.masterDataTable?.destroy) {
        this.masterDataTable.destroy()
      }
      FetchService.get("/getbuilding", (response) => {
        if (response) {
          response = JSON.parse(response)
          console.log("response", response)
          this.masterData = response.thisBuilding
          this.pageInit()
        }
      })
    },
    getCompanyData() {
      FetchService.get("/getcompany", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterFormData.companyData = response.allCompany
          this.formSetting.companyData = response.allCompany.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    pageInit() {

      let that = this

      let arrTable = this.masterData.map((row, index) => {
        let findCompany
        if (row?.company_id || row?.taxId) {
          findCompany = this.masterFormData.companyData.find(e => {
            return (row.company_id == e._id || row.company_id == e.name) || (e.taxId && row.taxId == e.taxId)
          })
        }
        return [
          row?._id ? row._id : "",
          row?.name ? row.name : "",
          row?.numberOfElevator ? row.numberOfElevator : "",
          row?.numberOfFloors ? row.numberOfFloors : "",
          row?.locationUrl ? row.locationUrl : "",
          findCompany?.name ? findCompany.name : "",
          `<button type="button" class="btn btn-warning mr-4 mb-2 btn-edit" style="cursor: pointer" value="${row?._id}">แก้ไข</button> <button type="button" class="btn btn-danger mr-4 btn-del" style="cursor: pointer" value="${row?._id}">ลบ</button>`,
        ]
      })

      // locationUrl
      // name
      // numberOfElevator
      // numberOfFloors
      // taxId
      // _id

      this.masterDataTable = new DataTable('#table_1', {
        data: arrTable,
        columns: [
          { title: 'Id' },
          { title: 'ชื่อตึก' },
          { title: 'จำนวนลิฟท์' },
          { title: 'จำนวนชั้น' },
          { title: 'พิกัด' },
          { title: 'บริษัท' },
          { title: 'ดำเนินการ' }
        ],
        dom: 'Bfrtip'
      });

      $('#table_1').on('click', '.btn-edit', (event) => {
        var data = event.currentTarget.value
        that.actionEditbuilding(data)
      });

      $('#table_1').on('click', '.btn-del', (event) => {
        var data = event.currentTarget.value
        that.actionDelbuilding(data)
      });

    },
    actionEditbuilding(buildingId) {
      this.buildingActionModal()
      const rowData = this.findMasterDataById(buildingId)

      let findCompany
      if (rowData?.company_id || rowData?.taxId) {
        findCompany = this.masterFormData.companyData.find(e => { return (rowData.company_id == e._id || rowData.company_id == e.name) || (rowData.taxId == e.taxId) })
      }

      this.buildingCreateForm = {
        buildingName: rowData.name,
        brandName: rowData.brandName,
        numberOfElevator: rowData.numberOfElevator,
        numberOfFloors: rowData.numberOfFloors,
        locationUrl: rowData.locationUrl,
        buildingData: rowData.buildingData,
        companyData: findCompany?._id ? findCompany._id : ""
      }

      this.buildingEditMode = 1
      this.buildingIdSelect = buildingId

    },
    actionDelbuilding(buildingId) {
      console.log("delbuilding", buildingId)
      this.buildingIdSelect = buildingId
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบบริษัท ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delbuilding()
        }
      })
    },
    findMasterDataById(id) {
      return this.masterData.find(e => {
        return e._id === id
      })
    },
    findMasterCompany(row) {
      let findCompany
      console.log(row)
      if (row?.company_id || row?.taxId) {
        findCompany = this.masterFormData.companyData.find(e => {
          return (row.company_id == e._id || row.company_id == e.name) || (e.taxId && row.taxId == e.taxId)
        })
      }
      return findCompany
    },
    buildingActionModal() {
      this.clearForm()
      this.$refs["buildingActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    addbuilding() {

      let set = $('#buildingCreateForm_companyData').val()
      var raw = JSON.stringify({
        "buildingName": this.buildingCreateForm.buildingName,
        "brandName": this.buildingCreateForm.brandName,
        "numberOfElevator": this.buildingCreateForm.numberOfElevator,
        "numberOfFloors": this.buildingCreateForm.numberOfFloors,
        "locationUrl": this.buildingCreateForm.locationUrl
      });

      FetchService.post("/addbuilding/" + set, raw, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.getCompanyData()
        this.$refs["buildingActionModal"].hide()
      })

    },
    editbuilding() {
      let set = $('#buildingCreateForm_companyData').val()
      var raw = JSON.stringify({
        "buildingName": this.buildingCreateForm.buildingName,
        "brandName": this.buildingCreateForm.brandName,
        "numberOfElevator": this.buildingCreateForm.numberOfElevator,
        "numberOfFloors": this.buildingCreateForm.numberOfFloors,
        "locationUrl": this.buildingCreateForm.locationUrl,
        "company_id": set,
      });

      FetchService.post(`/editbuilding/${this.buildingIdSelect}`, raw, res => {
        console.log(res)
        Swal.fire(
          'สำเร็จ',
          'แก้ไขข้อมูลแล้ว',
          'success'
        )

        this.getCompanyData()
        setTimeout(() => {
          this.getDataTable()
        }, 100)
        this.$refs["buildingActionModal"].hide()
      })
    },
    delbuilding() {
      FetchService.get(`/deletebuilding/${this.buildingIdSelect}`, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'ลบข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.getCompanyData()
        this.$refs["buildingActionModal"].hide()
      })
    },
    clearForm() {
      this.buildingCreateForm = {
        buildingName: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        locationUrl: "",
        companyData: ""
      }
      this.buildingEditMode = 0
    },
    confirmActionbuilding() {
      if (this.buildingCreateForm.buildingName == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่อบริษัท',
          'error'
        )
      } else {
        if (this.buildingEditMode === 1) {
          Swal.fire({
            title: 'ยืนยันการแก้ไข ?',
            text: "คุณยืนยันการแก้ไขบริษัท ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.editbuilding()
            }
          })
        } else {
          Swal.fire({
            title: 'ยืนยันการบันทึก ?',
            text: "คุณยืนยันการบันทึกบริษัท ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.addbuilding()
            }
          })
        }
      }
    }
  }
};

</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_1 table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_1 th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_1 thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_1 thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_1 thead tr:first-child th {
  border-top-style: solid;
}

#table_1 thead tr th:first-child {
  border-left-style: solid;
}

#table_1 td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_1 tbody th {
  border-style: none solid solid solid;
}

#table_1 tbody tr:first-child td:first-child {
  /* border-top-left-radius: 10px; */
}

#table_1 tbody tr:first-child td:last-child {
  /* border-top-right-radius: 10px; */
}

#table_1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_1 tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_1 tbody tr:first-child td {
  border-top-style: solid;
}

#table_1 tbody tr td:first-child {
  border-left-style: solid;
}

#table_1 tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_1 tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_1 tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}
</style>